import { AtlasRouteIds } from '@/components/navigation/constants';
import { FeatureFlagSet } from '@/types';

/**
 * Routes fully migrated from Darkwing; always served by Gaia (no LD gate).
 * Not used at runtime — discoverability for Phase 5 graduation status.
 */
export const MIGRATION_COMPLETE_ROUTES = [
  AtlasRouteIds.Alarms,
  AtlasRouteIds.CoincidentPeaks,
  AtlasRouteIds.CompressorSequencer,
  AtlasRouteIds.CondenserSequencer,
  AtlasRouteIds.DemandEvents,
  AtlasRouteIds.Equipment,
  AtlasRouteIds.FacilityPerformance,
  AtlasRouteIds.Map,
  AtlasRouteIds.Reports,
  AtlasRouteIds.System,
  AtlasRouteIds.Trends,
] as const satisfies readonly string[];

/**
 * Simple mapping of routes to their feature flags.
 * When a flag is:
 * - true: Gaia handles the feature
 * - false: Redirect to Darkwing
 *
 * These flags are managed in LaunchDarkly and control the gradual
 * migration of features from Darkwing to Gaia.
 */
export const ROUTE_FEATURE_FLAGS: Record<string, keyof FeatureFlagSet> = {
  [AtlasRouteIds.DemandResponseAdmin]: 'demand-response-pages',
  [AtlasRouteIds.DemandResponsePerf]: 'demand-response-pages',
  [AtlasRouteIds.ProcessView]: 'gaia-process',
  // Add more routes as they are migrated
} as const;

/**
 * Checks if a route has a feature flag configured.
 * @param value - The route identifier to check
 * @returns The feature flag key if configured, false otherwise
 */
export const hasRouteFeatureFlag = (value: string) =>
  (value && ROUTE_FEATURE_FLAGS[value]) ?? false;
